import React from 'react';

import { Outlet, RouteObject } from 'react-router-dom';

import withRoute, { withRegionLockedRoute } from 'components/common/Route';

import Privacy from './Privacy';

import DataStreamScreen from 'components/Privacy/DataStreamScreen';
import DataStreamSetupScreen from 'components/Privacy/DataStreamScreen/DataStreamSetupScreen';
import OAuthCallback from 'components/Privacy/DataStreamScreen/OAuthCallback';

import DownloadDataScreen from 'components/Privacy/DownloadData';

export const PrivacyLayout = () => <Outlet />;

const routes: RouteObject[] = [
  {
    path: '*',
    Component: () => withRoute(Privacy),
  },
  {
    path: 'data-stream',
    Component: () =>
      withRegionLockedRoute(DataStreamScreen, '/privacy-and-data'),
  },
  {
    path: 'data-stream/setup',
    Component: () =>
      withRegionLockedRoute(DataStreamSetupScreen, '/privacy-and-data'),
  },
  {
    path: 'data-stream/oauth/callback',
    Component: () => withRegionLockedRoute(OAuthCallback, '/privacy-and-data'),
  },
  {
    path: 'data-requests',
    Component: () => withRoute(DownloadDataScreen),
  },
];

export default routes;
